import { render, staticRenderFns } from "./ActionAuthorization.vue?vue&type=template&id=208e6ceb&scoped=true"
import script from "./ActionAuthorization.vue?vue&type=script&lang=js"
export * from "./ActionAuthorization.vue?vue&type=script&lang=js"
import style0 from "./ActionAuthorization.vue?vue&type=style&index=0&id=208e6ceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e6ceb",
  null
  
)

export default component.exports